module.exports = __webpack_public_path__ + "img/close.177a214d.svg";